import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import Topbar from "../../components/Topbar";
import { Colors } from "../../config";
import { getParentPath } from "../../helper";
import { fetchUserData, tokenRegister } from "../../services/userServices";
import Tutorials from "../../components/Tutorials";
import VideoTutorial from "../../components/VideoTutorial";
import BizTripTutorialOverlay from "../../components/BusinessTripComponents/TutorialOverlay";
import { getDropdownsForReason } from "../../services/bookingServices";
import { useProfileContext } from "../../contexts/ProfileContext";
import { useLoaderContext } from "../../contexts/loaderContext";

const dashboardBg = require("../../assets/images/bg_full.png");
const mobileBg = require("../../assets/images/bg_mobile.png");

const Dashboard = () => {
  let navigate = useNavigate();
  let params = useParams();
  const location = useLocation();
  let token = localStorage.getItem("firebaseEmployeeToken");
  const { setLoader } = useLoaderContext();

  const [activePath, setActivePath] = useState("dashboard");
  const [showTutorial, setShowTutorial] = useState(false);
  const [showBizTripTutorial, setShowBizTripTutorial] = useState(false);
  const [walkthroughIndex, setWalkthroughIndex] = useState(0);
  const [settings, setSettings] = useState(null);
  const { profile, setProfile } = useProfileContext();
  useEffect(() => {
    let path =
      Object.keys(params).length === 0
        ? location.pathname.split("/")[location.pathname.split("/").length - 1]
        : location.pathname.split("/")[location.pathname.split("/").length - 2];

    let parentPath = getParentPath(path);
    setActivePath(parentPath);
  }, [location]); // eslint-disable-line

  useEffect(() => {
    fetchSettings();
  }, [profile]);

  useEffect(() => {
    if (profile?.personId) {
    } else {
      fetchProfile();
    }
  }, [profile]);

  const fetchProfile = async () => {
    setLoader(true);
    try {
      let profileResponse = await fetchUserData();
      let data = profileResponse?.data;
      setProfile({ ...data?.data });
    } catch (err) {
    } finally {
      setLoader(false);
    }
  };

  const fetchSettings = async () => {
    let res = await getDropdownsForReason();
    console.log("res?.data?.data");
    setSettings(res?.data?.data);
    console.log(profile?.countryOfCompany);
  };

  useEffect(() => {
    let shownTutorial = localStorage.getItem("shownTutorial");
    console.log(shownTutorial);
    setShowTutorial(
      shownTutorial === "false" || shownTutorial === null ? true : false,
    );
  }, []);

  useEffect(() => {
    let shownBizTripTutorial = localStorage.getItem("shownBizTripTutorial");
    console.log(shownBizTripTutorial);
    setShowBizTripTutorial(
      shownBizTripTutorial === "false" || shownBizTripTutorial === null
        ? true
        : false,
    );
  }, []);

  const handleRoute = (path) => {
    setActivePath(path);
    navigate(path);
  };

  useEffect(() => {
    registerFirebase();
  }, [token]);

  const handleOnDone = () => {
    setShowTutorial(false);
    localStorage.setItem("shownTutorial", true);
  };

  const registerFirebase = async () => {
    try {
      if (token) {
        const response = await tokenRegister({ token });
        console.log("Token registered successfully", response);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleBookBizTripClick = () => {
    setWalkthroughIndex(walkthroughIndex + 1);
  };
  const handleOkClick = () => {
    setShowBizTripTutorial(false);
  };

  return (
    <>
      {showTutorial && <VideoTutorial onDone={handleOnDone} />}
      {showBizTripTutorial &&
        !(
          settings?.business_trip_restricted_company?.includes(
            profile?.countryOfCompany,
          ) || !profile.enableBusinessTrip
        ) && (
          <BizTripTutorialOverlay
            walkthroughIndex={walkthroughIndex}
            onBookBizTripClick={handleBookBizTripClick}
            onOkClick={handleOkClick}
            onPrevious={() => {
              if (walkthroughIndex === 1) {
                setWalkthroughIndex(1);
              } else {
                setWalkthroughIndex(walkthroughIndex - 1);
              }
            }}
            onNext={() => {
              if (walkthroughIndex === 11) {
                setShowBizTripTutorial(false);
                navigate("/user/business");
                localStorage.setItem("shownBizTripTutorial", "true");
              } else {
                setWalkthroughIndex(walkthroughIndex + 1);
              }
            }}
            onSkip={() => {
              setShowBizTripTutorial(false);
              navigate("/user/business");
              setWalkthroughIndex(0);
            }}
          />
        )}
      <DashboardContainer location={location.pathname === "/user/dashboard"}>
        {
          <StyledTopbar>
            <Topbar
              hideBizTrip={
                settings?.business_trip_restricted_company?.includes(
                  profile?.countryOfCompany,
                ) || !profile.enableBusinessTrip
              }
              activePath={activePath}
              onRoute={handleRoute}
              showBizTripTutorial={
                showBizTripTutorial && walkthroughIndex === 0
              }
            />
          </StyledTopbar>
        }

        <OutletContainer>
          <Outlet />
        </OutletContainer>
      </DashboardContainer>
    </>
  );
};

export default Dashboard;

const DashboardContainer = styled.div`
  background:
    linear-gradient(rgba(0, 7, 12, 0.7), rgba(0, 7, 12, 0.7)),
    url(${dashboardBg}) no-repeat center;
  background-size: cover;
  background-attachment: fixed;
  width: 100%;
  height: 100vh;
  @media only screen and (max-width: 768px) {
    background: none;
  }
`;
const StyledTopbar = styled.div`
  width: 100%;
`;

const OutletContainer = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  height: calc(100vh - 6.5rem);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0.875rem;
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar-thumb {
    height: 3.625rem;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 0.625rem;
    background-color: ${Colors.brandOne};
  }
  @media only screen and (max-width: 768px) {
    background: url(${mobileBg}) no-repeat;
    background-size: cover;
    height: calc(100vh - 6.5rem);
    &::-webkit-scrollbar {
      display: none;
    }
    &::-webkit-scrollbar-thumb {
      display: none;
    }
  }
`;
